import { connect } from 'react-redux';
import {
  selectUsesWc2026Bracket,
  getWildcardStartRound,
  selectTeamGroupByCode,
} from '@selectors/matches';
import { 
  selectDisplayBrackets,
  selectViewAssertionsByMid,
  withViewAssertions,
} from '@selectors/bracketView';
import get from 'lodash/get';

import BracketMobile from './BracketMobile';
import { Bracket as BracketType, Round } from '@models/Match';

const WC2026_ROUND_TITLES = [
  'Dieciseisavos',
  'Octavos',
  'Cuartos',
  'Semifinales',
  '3° Puesto',
  'Final',
];

const WC2026_ROUND_KEYS = [
  Round.Roundof32,
  Round.Roundof16,
  Round.Quarter,
  Round.Semi,
  Round.Third,
  Round.Final,
];

const LEGACY_ROUND_KEYS = [
  Round.Roundof16,
  Round.Quarter,
  Round.Semi,
  Round.Third,
  Round.Final,
];

export const mapStateToProps = (state) => {
  let section = selectDisplayBrackets(state) || {};
  const assertionsByMid = selectViewAssertionsByMid(state);

  // Helper para inyectar assertions en arrays de matches o matches individuales
  const injectAssertions = (data) => {
    if (Array.isArray(data)) {
      return withViewAssertions(data, assertionsByMid);
    }
    if (data && typeof data === 'object' && data.mid) {
      return withViewAssertions([data], assertionsByMid)[0];
    }
    return data;
  };

  const usesWc2026Bracket = selectUsesWc2026Bracket(state);
  const firstKnockout = usesWc2026Bracket
    ? Round.Roundof32
    : Round.Roundof16;
  const forward = section[BracketType.Forward] || {};
  const reverse = section[BracketType.Reverse] || {};
  const final = Array.isArray(section[BracketType.Final])
    ? section[BracketType.Final]
    : [];

  const wildcardStartRound = getWildcardStartRound(state);
  const roundKeys = usesWc2026Bracket ? WC2026_ROUND_KEYS : LEGACY_ROUND_KEYS;
  const selectableFromIndex = wildcardStartRound
    ? Math.max(0, roundKeys.indexOf(wildcardStartRound))
    : 0;

  return {
    roundNames: usesWc2026Bracket ? WC2026_ROUND_TITLES : undefined,
    selectableFromIndex,
    teamGroupByCode: selectTeamGroupByCode(state),
    rounds: usesWc2026Bracket
      ? [
          [
            injectAssertions(get(forward, Round.Roundof32, [])),
            injectAssertions(get(reverse, Round.Roundof32, [])),
          ],
          [
            injectAssertions(get(forward, Round.Roundof16, [])),
            injectAssertions(get(reverse, Round.Roundof16, [])),
          ],
          [
            injectAssertions(get(forward, 'quarter', [])),
            injectAssertions(get(reverse, 'quarter', [])),
          ],
          [
            injectAssertions(get(forward, 'semi', [])),
            injectAssertions(get(reverse, 'semi', [])),
          ],
          [[injectAssertions(get(final, '[1]', {}))]],
          [[injectAssertions(get(final, '[0]', {}))]],
        ]
      : [
          [
            injectAssertions(get(forward, firstKnockout, [])),
            injectAssertions(get(reverse, firstKnockout, [])),
          ],
          [
            injectAssertions(get(forward, 'quarter', [])),
            injectAssertions(get(reverse, 'quarter', [])),
          ],
          [
            injectAssertions(get(forward, 'semi', [])),
            injectAssertions(get(reverse, 'semi', [])),
          ],
          [[injectAssertions(get(final, '[1]', {}))]],
          [[injectAssertions(get(final, '[0]', {}))]],
        ],
  };
};

export default connect(mapStateToProps)(BracketMobile);
